import HTTP from './HTTP.js';
import SymfonyErrorFormatter from "./SymfonyErrorFormatter";

class ActivitiesServices {
    static getActivities(cursor) {
        return HTTP.get(`activities`,{
            params: {
                cursor: cursor,
                limit: 10
            }
        })
            .then((response) => {
                return {
                    data: response.data.activities,
                    meta: response.data.meta
                }
            }).catch(() => {
                return Promise.reject('Could not get End Point');
        });
    }

    static getCountActivities() {
        return HTTP.get(`activities/count`,{
        })
            .then((response) => {
                return {
                    data: response.data.total,
                    meta: response.data.meta
                }
            }).catch(() => {
                return Promise.reject('Could not get End Point');
            });
    }

    static getTopActivities() {
        return HTTP.get(`activities/top`,{
        })
            .then((response) => {
                return {
                    data: response.data.activities,
                    meta: response.data.meta
                }
            }).catch(() => {
                return Promise.reject('Could not get End Point');
            });
    }

    static updateIsReadActivities() {
        return HTTP.post(`activities`)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

}

export default ActivitiesServices;
